;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

const listOrganizationGroupsPage = gql`
  query listOrganizationGroupsPage(
    $pOrgId: UUID!
    $first: Int = 6
    $offset: Int = 0
  ) {
    listOrganizationGroups(pOrgId: $pOrgId, first: $first, offset: $offset) {
      edges {
        node {
          groupActive
          groupDescription
          groupId
          groupName
          groupPhotoUrl
          groupPublished
          groupType
          providerFirstName
          providerLastName
          providerPhotoUrl
          providerPreferredName
          providerPreferredFirstName
          providerPreferredLastName
          providerPrimaryCredential
          providerPrimaryRole
          providerUserId
        }
      }
      totalCount
    }
  }
`

export default listOrganizationGroupsPage
